import request from "@/utils/request";

export default function addChargeTemplate(data) {
    return request({
        url: '/device/chargeTemplate/add',
        method: 'post',
        data
    })
}
